import { Dropdown, Typography } from '@vtblife/uikit';
import React, { useState, useRef, useEffect } from 'react';
import classname from '@search/classname/src';
import './ExpandableDescription.css';

const MAX_HEIGHT = 120;

export const cn = classname.bind(null, 'ExpandableDescription');

export const ExpandableDescription = ({
    description,
    isMobile = false,
    isDeleted = false
}: {
    description: string;
    isMobile?: boolean;
    isDeleted?: boolean;
}) => {
    const [ showMore, setShowMore ] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);
    const [ textHeight, setTextHeight ] = useState(MAX_HEIGHT);

    const handleShowMore = () => {
        setShowMore(state => ! state);
    };

    useEffect(() => {
        if (textRef.current) {
            setTextHeight(showMore ? textRef?.current.scrollHeight : MAX_HEIGHT);
        }
    }, [ showMore, description ]);

    return (
        <>
            <div
                ref={textRef}
                style={{ maxHeight: `${textHeight}px` }}
                className={cn('description-container', { isMobile })}
            >
                <Typography
                    variant='primary'
                    itemProp='description'
                    className={cn('description', { isDeleted })}
                >
                    {description}
                </Typography>
            </div>
            {textRef.current && textRef.current.scrollHeight > MAX_HEIGHT && (
                <Dropdown.SimpleControl arrow onToggle={handleShowMore} opened={showMore}>
                    {showMore ? 'Скрыть' : 'Читать полностью'}
                </Dropdown.SimpleControl>)
            }
        </>
    );
};
